import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";

interface ComponentProps {
    isOpen: boolean;
    closeAction: any;
    action: any;
}

export default function DeleteDialog({
                                         isOpen,
                                         closeAction,
                                         action,
                                     }: ComponentProps) {
    return (
        <Dialog open={isOpen} onClose={closeAction}>
            <DialogTitle>Törlés megerősítése</DialogTitle>
            <DialogContent>
                <DialogContentText>Biztosan törölni szeretnéd?</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button color="error" variant="contained" onClick={closeAction}>
                    Nem
                </Button>
                <Button color="success" variant="contained" onClick={action}>
                    Igen
                </Button>
            </DialogActions>
        </Dialog>
    );
}
